import { useTranslation } from '@/i18n';
import { ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { ApprovalStepHeadingProps } from '../../types';
import { ApprovalStepStatus } from '../ApprovalStepStatus';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const ApprovalStepHeading: FC<ApprovalStepHeadingProps> = ({
  condition,
  stepName,
  status,
  isShowCondition,
}) => {
  const { t } = useTranslation();
  const isShowStatus =
    status &&
    status !==
      ApprovingInvoiceReportApprovalRouteResponseStepsItemStatus.not_approved;
  return (
    <div className={cx('container')}>
      {isShowStatus && <ApprovalStepStatus status={status} />}
      <div className={cx('step-text')}>{stepName}</div>
      {isShowCondition && (
        <div className={cx('condition-text')}>
          {t('approving_invoice_reports.condition')}：{condition}
        </div>
      )}
    </div>
  );
};
